'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import * as SliderPrimitive from '@radix-ui/react-slider';
import { cn } from '@workspace/ui/lib';
import * as React from 'react';

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn('relative flex w-full touch-none items-center select-none', className)}
    {...props}
  >
    <SliderPrimitive.Track className="bg-grey-100 dark:bg-grey-800 relative h-4 w-full grow overflow-hidden rounded-full">
      <SliderPrimitive.Range className="bg-neutral-200 dark:bg-neutral-100 absolute h-full" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className="border-neutral-200 bg-grey-100 focus-visible:ring-neutral-200 dark:border-neutral-100 dark:bg-neutral-200 block size-4 rounded-full border shadow-sm focus-visible:ring-2 focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50" />
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
